import { debounce } from "lodash";
import { Grid, Pagination } from "@mui/material";
import { Fragment, useEffect, useState } from "react";

import pages from "../../constants/pages";
import EmptyList from "../misc/EmptyList";
import List from "./list components/List";
import { useAxios, useComponent } from "../../hooks";
import { Loader, PageHeader } from "../../components";
import { PrimaryButton } from "../css components/Button";
import Search from "../audience components/audience list components/Search";
import FloatingAddActionButtons from "../../components/FloatingAddActionButton";
import SetSequenceGroup from "./list components/SetSequenceDialog";

export default function GroupList() {
  const axios = useAxios();
  const { loader } = useComponent();

  const [page, setPage] = useState(1);
  const [groups, setGroups] = useState([]);
  const [popUp, setPopUp] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const [lastPage, setLastPage] = useState({ totalCount: 0, lastPage: false });

  useEffect(() => {
    loader.start();
    axios({
      url:
        "/list/fieldsGroups" +
        (searchKey ? `?search=${encodeURIComponent(searchKey)}` : ""),

      disableRedirect: true,
    }).then((response) => {
      if (response.status) {
        setGroups(response.data);
      }
      loader.stop();
    });
  }, [loader, axios, searchKey]);

  const handleSearchDebounce = debounce(async (value) => {
    setSearchKey(value);
  }, 300);

  function handlePagination(step, index) {
    setPage((prev) =>
      step === "index" ? index : prev + (step === "next" ? 1 : -1)
    );
  }

  return (
    <Fragment>
      <Grid container spacing={3}>
        <Grid size={12}>
          <PageHeader
            pageName={"Groups"}
            pageHeader="List of Groups"
            icons={[
              <Search
                handleSearchDebounce={handleSearchDebounce}
                setPage={setPage}
              />,
            ]}
            buttons={[
              <PrimaryButton variant="contained" onClick={() => setPopUp(true)}>
                Group Sequence
              </PrimaryButton>,
            ]}
          />
        </Grid>
      </Grid>

      <FloatingAddActionButtons
        title={"Add Group "}
        route={pages.groupCreatePage.route}
      />

      <Loader height="75%">
        {groups.length > 0 ? (
          <List groups={groups} />
        ) : (
          <EmptyList
            title={"No groups found."}
            button={"Create Group"}
            route={pages.groupCreatePage.route}
          />
        )}
      </Loader>

      {!!lastPage.totalCount && (
        <Grid item container display={"flex"} justifyContent={"center"}>
          <Pagination
            count={Math.ceil(lastPage.totalCount / 10)}
            variant="outlined"
            color="secondary"
            page={page}
            onChange={(e, value) => handlePagination("index", value)}
          />
        </Grid>
      )}

      <SetSequenceGroup
        setGroups={setGroups}
        popUp={popUp}
        setPopUp={setPopUp}
        sequence={groups}
      />
    </Fragment>
  );
}
